import { Link } from "gatsby"
import React from "react"
import "./info.scss"

export const InfoSection = () => {
  return (
    <div className="automatizacion-info-container">
      <div
        className="automatizacion-crestron-container"
        data-sal="slide-up"
        data-sal-delay="200"
        data-sal-easing="ease"
      >
        <div className="creston-title-container">
          <h2 className="creston-title">CRESTRON ELECTRONICS</h2>
        </div>
        <div className="crestron-text-container">
          <p>
            Es líder mundial en sistemas avanzados de control y automatización,
            innovando tecnología y reinventado la manera de cómo la gente vive y
            trabaja. Ofrece integrar soluciones de audio, video, iluminación,
            HVAC y más, mejorando la calidad de vida en corporativos, escuelas y
            universidades, cuartos de control, auditorios y más.
          </p>
          <p>
            Las soluciones integrales de Crestron simplifican el uso práctico de
            la tecnología en los espacios, logrando la creación de ambientes y
            escenarios de acuerdo a las necesidades únicas de cada usuario,
            convirtiendo complejas secuencias de operación, en sencillas y
            rápidas de operar desde una interfaz de usuario, como es una
            pantalla sensible al tacto con gráficos intuitivos para el usuario.
          </p>
        </div>
      </div>
      <div
        className="automatizacion-kramer-container"
        data-sal="slide-up"
        data-sal-delay="200"
        data-sal-easing="ease"
      >
        <div className="kramer-title-container">
          <h2>KRAMER</h2>
        </div>
        <div
          className="kramer-text-container"
          data-sal="slide-up"
          data-sal-delay="200"
          data-sal-easing="ease"
        >
          <p>
            Es un líder industrial en productos de calidad, rentabilidad y
            satisfacción al cliente. Con una red y un personal mundial de
            primera clase de distribución, en oficinas y almacenes de ventas
            alrededor del mundo, Kramer se dedica a suministrar soluciones
            valiosas de producto y una experiencia inigualable en el servicio al
            cliente. Desde el primer contacto al servicio post venta y soporte,
            la puerta a Kramer, siempre está abierta.
          </p>
          <p>
            El cometido de Kramer con el suministro de productos fiables no
            queda en segundo lugar. Con un completo rango de productos tales
            como el Selector/Escalador Digital ProScale™, conversores de
            exploración matrices de conmutación y selectores de presentación y
            nuestra famosas mundialmente Kramer TOOLS™, nuestras soluciones son
            extensas.
          </p>
          <p>
            Podrá encontrar en Kramer una gran variedad de aplicaciones– desde
            una simple solución a un completo sistema integrado – para usos
            comercial, eduacional. Kramer se enorgullece de la fabricación de
            conexiones…. a través de nuestros productos y nuestra gente.
          </p>
        </div>
      </div>
      <div
        className="automatizacion-button-container"
        data-sal="slide-up"
        data-sal-delay="200"
        data-sal-easing="ease"
      >
        <Link className="soluciones-btn" to="/contacto">
          <button className="automatizacion-btn-cotizar">COTIZAR</button>
        </Link>
      </div>
    </div>
  )
}
